module.exports = "mutation UpdateProductInsert($data:ProductInsertInput!){updateProductInsert(data:$data){success}}"